'use es6';

import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
export default createTracker({
  events
});